import './utils/ajax';
import './utils/spinner';
import Cart from './cart/Cart';
import Panel from './Panel';
import Form from '../../modules/core/forms/theme/js/Form';
import Utils from '../../modules/utils/utils-js/theme/js/utils/Utils';
import SiteProduct from './SiteProduct';
import OpenInfo from '../../modules/utils/utils-js/theme/js/utils/OpenInfo';
import ObjectFit from '../../modules/utils/utils-js/theme/js/utils/ObjectFit';
import Switcher from './utils/Switcher';
import Favorites from './mods/Favorites';
import * as CookieConsent from 'vanilla-cookieconsent';

declare let Slider;
declare let FB;

export default class Site {
    public static MOBILE_WIDTH = 1270;

    public static Cart:Cart = Cart;
    public static Panel:Panel = Panel;
    public static Favorites = Favorites;

    private static initProdFilters($form: JQuery): void {
        const $checks = $('.prodfilters__checks', $form);

        $checks.each((ix, el) => {
            const $el = $(el);
            const max = parseInt($el.data('max'));

            const $items = $('.checklist-items__item', $el);
            const $more = $('.prodfilters__more', $el);

            if ($items.length > max) {
                const $last = $items.slice(max);

                let vis = false;

                $more.on('click', (e) => {
                    vis = !vis;

                    if (vis) {
                        $last.slideDown();
                        $more.text('[-] mniej');
                    } else {
                        $last.slideUp();
                        $more.text('[+] więcej');
                    }
                });

                $more.text('[+] więcej');
                $last.hide();
            } else {
                $more.hide();
            }
        });

        $form.on('submit', (e) => {
            e.preventDefault();

            $.ajax({
                url: '/productfilters',
                method: 'get',

                data: $form.serializeArray(),

                success: (r) => {
                    window.location.href = r.url;
                }
            });
        });
    }

    public static onCategoryPage(): void {
        $(() => {
            const $uid = $('.vproducts');
            const $filters = $('.filters .sortby select', $uid);

            const $switchers = $('.filterbox__switcher', $uid);
            const $list = $('.productboxlist', $uid);
            const $products = $('.productbox', $list);

            const switchfunc = (ix) => {
                const $sel = $switchers.eq(ix);

                $switchers.not($sel).removeClass('filterbox__switcher--selected');
                $sel.addClass('filterbox__switcher--selected');

                const name = $sel.data('type');

                $list.removeClass('productboxlist--grid productboxlist--list');
                $list.addClass('productboxlist--' + name);

                $products.removeClass('productbox--grid productbox--list');
                $products.addClass('productbox--' + name);
            };

            $filters.on('change', () => {
                const $form = $(this).closest('form');

                $form.submit();
            });

            $switchers.each((ix, el) => {
                const $switcher = $(el);

                $switcher.on('click', (e) => {
                    const $sel = $switchers.eq(ix);
                    const name = $sel.data('type');

                    switchfunc(ix);

                    window.localStorage.setItem('list_type', name);
                });
            });

            var name = 'grid';

            if (window.innerWidth >= Site.MOBILE_WIDTH) {
                const lst = window.localStorage.getItem('list_type');

                if (lst != null) {
                    name = lst;
                }
            }

            switchfunc(name == 'grid' ? 0 : 1);

            this.initProdFilters($('.prodfilters', $uid));

            setTimeout(() => {
                $list.addClass('productboxlist--inited');
                $uid.addClass('vproducts--inited');
            }, 10);
        });
    }

    public static onProductPage(): void {
        $('.vproduct__addtocart .button--fav').each((ix, el) => {
            const $el = $(el);

            Favorites.initFavButton($el);
        });
    }

    public static onRelatedProducts($uid: JQuery): void {
        $(() => {
            const $buttons = $('.relatedproducts__button', $uid);
            const $items = $('.relatedproducts__item', $uid);
            const $switchers = $('.relatedproducts__switcher', $uid);
            const $list = $('.productboxlist', $uid);
            const $products = $('.productbox', $list);

            const selectfunc = (ix) => {
                const $selbutton = $buttons.eq(ix);
                const $selitem = $items.eq(ix);

                $buttons.not($selbutton).removeClass('relatedproducts__button--selected');
                $selbutton.addClass('relatedproducts__button--selected');

                $items.not($selbutton).removeClass('relatedproducts__item--selected');
                $selitem.addClass('relatedproducts__item--selected');
            };

            const switchfunc = (ix) => {
                const $sel = $switchers.eq(ix);

                $switchers.not($sel).removeClass('relatedproducts__switcher--selected');
                $sel.addClass('relatedproducts__switcher--selected');

                const name = $sel.data('type');

                $list.removeClass('productboxlist--grid productboxlist--list');
                $list.addClass('productboxlist--' + name);

                $products.removeClass('productbox--grid productbox--list');
                $products.addClass('productbox--' + name);
            };

            $buttons.each((ix, el) => {
                const $button = $(el);

                $button.on('click', (e) => {
                    selectfunc(ix);
                });
            });

            $switchers.each((ix, el) => {
                const $switcher = $(el);

                $switcher.on('click', (e) => {
                    switchfunc(ix);
                });
            });

            selectfunc(0);
            switchfunc(0);

            setTimeout(() => {
                $list.addClass('productboxlist--inited');
            }, 10);
        });
    }

    public static dispatchUpdateCartStart(): void {
        // $('#cartsummary').ajaxLoader();
        $('body').trigger('cartUpdateInit');
    }

    public static dispatchUpdateCart(): void {
        let timer = null;

        if (timer !== null) {
            window.clearTimeout(timer);
            timer = null;
        }

        $.get('/cartapi/info', (info) => {
            const $headercart = $('.header__controls-cart');

            $headercart.addClass('flash');
            $('.totalquantityinfo', $headercart).text(info.total);
            $('.price', $headercart).html(info.amount_html);

            setTimeout(() => {
                $headercart.removeClass('flash');
            }, 2000);
        });

        $('body').trigger('cartUpdate');
    }

    public static onRegisterForm($uid: JQuery): void {
        new Form($uid);

        Switcher.initVal($('input[name="iscompany"]', $uid), 1, $('._js-forcompany', $uid));

        Switcher.initVal($('input[name="sameaddress"]', $uid), 1, $('._js-forsameaddress', $uid), true);

        Switcher.initVal($('input[name="send_iscompany"]', $uid), 1, $('._js-forcompany2', $uid));

        (<any> Site).discover($uid);
    }

    public static onPageHome(): void {
        new Slider($('.mainslider'), {
            fixed: true,
            max: 1
        });
    }

    public static discover($parent?: JQuery): void {
        Utils.updateElements($parent);
        Cart.discover($parent);

        Form.initRadios($('.vproduct .radio-items', $parent));

        (<any> $('.tooltipped', $parent)).tooltip();
    }

    private static updateFloat() {
        const top = $(window).scrollTop();
        const wh = $(window).height();
        const wx = $(window).width();

        const $body = $('body');
        const $header = $('.header');
        const $mainmenu = $('.mainmenu');
        const $menu = $('.menu--main');

        $body.toggleClass('body--float', top > 0);
        $body.toggleClass('body--no-float', top == 0);
        $body.toggleClass('body--float-100', top > wh);
        $body.toggleClass('body--float-ac', top > wh - 130);

        // $mainmenu.toggleClass('mainmenu--mobile', top > 0 || wx <= 768);
        // $mainmenu.toggleClass('mainmenu--full', top == 0 && wx > 768);

        // $menu.toggleClass('menu--mobile', top > 0 || wx <= 768);
        // $menu.toggleClass('menu--full', top == 0 && wx > 768);

        // $header.toggleClass('header--mobile', top > 0 || wx <= 768);
        // $header.toggleClass('header--full', top == 0 && wx > 768);

        $mainmenu.toggleClass('mainmenu--mobile', wx <= Site.MOBILE_WIDTH);
        $mainmenu.toggleClass('mainmenu--full', wx > Site.MOBILE_WIDTH);

        $menu.toggleClass('menu--mobile', wx <= Site.MOBILE_WIDTH);
        $menu.toggleClass('menu--full', wx > Site.MOBILE_WIDTH);

        $header.toggleClass('header--mobile', wx <= Site.MOBILE_WIDTH);
        $header.toggleClass('header--full', wx > Site.MOBILE_WIDTH);
    }

    private static windowOpen(url, name): void {
        var width = 575;
        var height = 300;

        var left = ($(window).width()  - width)  / 2;
        var top = ($(window).height() - height) / 2;

        var opts = 'status=1,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left;

        return (<any> window).open(url, name, opts);
    }

    private static initShares($parent?: JQuery): void {
        $('.js-share--facebook', $parent).click((e) => {
            e.preventDefault();

            FB.ui({
                method: 'share',
                href: window.location.href
            });
        });

        $('.js-share--twitter', $parent).click((e) => {
            e.preventDefault();

            this.windowOpen('https://twitter.com/share', 'twitter');
        });
    }

    private static initProductBoxes(): void {
        $('.productbox').each((ix, el) => {
            const $el = $(el);

            const $fav = $('.productbox__fav', $el);

            Favorites.initFavButton($fav);
        });
    }

    private static initBigCat(): void {
        const $el = $('.header__categories');
        const $button = $('button', $el);

        let $bigcat: JQuery = null;
        let $bigbody: JQuery = null;
        let $subs = {};

        const togglefunc = () => {
            $bigcat.toggleClass('bigcat--opened');
        };

        const showfunc = (id: number) => {
            $bigbody.html($subs[id]);
        };

        let bypass = false;

        $button.on('click', (e) => {
            if ($bigcat != null) {
                togglefunc();
            } else {
                $.get('/bigcat', (html) => {
                    $bigcat = $(html);
                    $bigbody = $('.bigcat__body', $bigcat);

                    const $items = $('.bigcat__main-item', $bigcat);
                    $items.each((ix, el) => {
                        const $item = $(el);
                        const id = parseInt($item.data('id'));

                        $item.on('mouseover', (e) => {
                            $items.removeClass('bigcat__main-item--selected');
                            $item.addClass('bigcat__main-item--selected');

                            if ($subs[id]) {
                                showfunc(id);
                            } else {
                                if (bypass) {
                                    return;
                                }

                                bypass = true;

                                $.get('/bigcat/' + id, (html) => {
                                    $subs[id] = $(html);

                                    showfunc(id);

                                    bypass = false;
                                });
                            }
                        });
                    });

                    $el.append($bigcat);
                    this.discover($bigcat);

                    togglefunc();
                });
            }
        });
    }

    private static initGoTop(): void {
        const $gotop = $('.gotop');
        const $svg = $('svg', $gotop);

        const progressPath: any = <any> $('path', $svg)[0];

        var pathLength = progressPath.getTotalLength();
        progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
        progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
        progressPath.style.strokeDashoffset = pathLength;
        progressPath.getBoundingClientRect();
        progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';

        const updateProgress = () => {
            const scroll = $(window).scrollTop();
            const height = $(document).height() - $(window).height();
            const progress = pathLength - (scroll * pathLength / height);
            progressPath.style.strokeDashoffset = progress;
        }

        $(window).scroll(updateProgress);
        updateProgress();

        $(window).on('scroll', () => {
            $gotop.toggleClass('gotop--visible', $(window).scrollTop() > 100);
        });

        $gotop.toggleClass('gotop--visible', $(window).scrollTop() > 100);

        $gotop.on('click', (e) => {
            e.preventDefault();

            $('html, body').animate({scrollTop: 0}, 550);
        })
    }

    private static initCategories() {
        let $items = $('.categorieslist__item');

        $items.each((ix, el) => {
            let $el = $(el);

            let $head = $('> .categorieslist__head', $el);
            let $switch = $('.categorieslist__switch', $head);
            let $children = $('> .categorieslist', $el);

            $switch.click(() => {
                $el.toggleClass('categorieslist__item--opened');
                $children.slideToggle();
            });
        });

        let $focused = $('.categorieslist__item--selected', $items).parents('.categorieslist__item');
        $focused.addClass('categorieslist__item--opened categorieslist__item--focused');
        $('> .categorieslist', $focused).show();
    }

    private static initSearchBar(): void {
        const $form = $('.searchbar');
        const $filter = $('.searchbar__filter', $form);
        const $items = $('.searchbar__list li', $form);
        const $select = $('.searchbar__selected', $form);
        const $text = $('span', $select);
        const $query = $('input', $form);
        // const $button = $('.searchbar__button', $form);

        const selectfunc = ($item: JQuery) => {
            $form.data('url', $item.data('url'));
            $text.text($item.text());
        };

        $select.on('click', (e) => {
            $filter.toggleClass('searchbar__filter--opened');
        });

        $items.each((ix, el) => {
            const $item = $(el);

            $item.on('click', () => {
                $filter.removeClass('searchbar__filter--opened');

                selectfunc($item);
            });
        });

        const $results = $(`
            <div class="searchbar__results">
                <div class="searchbar__results-inner">
                </div>
            </div>
        `);

        const $resultsinner = $('.searchbar__results-inner', $results);

        $results.appendTo($form);

        const showResults = (query?: string) => {
            if (query) {
                $.ajax({
                    url: '/search/query',
                    data: {
                        q: query
                    },

                    success: (r) => {
                        $resultsinner.html(r.html);
                        $results.addClass('searchbar__results--opened');
                    },

                    error: (r) => {
                        $results.removeClass('searchbar__results--opened');
                    },
                });
            } else {
                $results.removeClass('searchbar__results--opened');
            }
        };

        let showtimer = null;

        $query.on('keyup', (e) => {
            const val = $query.val();

            if (val.length < 3 || e.keyCode == 27) {
                showResults(null);

                if (showtimer) {
                    clearTimeout(showtimer);
                    showtimer = null;
                }
            } else {
                if (showtimer) {
                    clearTimeout(showtimer);
                    showtimer = null;
                }

                showtimer = setTimeout(() => {
                    showResults(val);
                }, 300);
            }
        });

        $(document).on('click', (e) => {
            if ($results.hasClass('searchbar__results--opened')) {
                const $target = $(e.target);

                if ($target.closest($results).length == 0) {
                    showResults(null);
                }
            }
        });

        $form.on('submit', (e) => {
            e.preventDefault();

            let url = $form.data('url');
            url += '?q=' + encodeURIComponent($query.val());

            window.location.href = url;
        });
    }

    public static initGalleries(): void {
        let $galleries = $('.gallery__list');

        if (!$galleries.length) {
            return;
        }

        $galleries.each((ix, el) => {
            let $items = $('.gallery__link', $(el));
            let $srcs: Array<object> = [];

            $items.each(function () {
                $srcs.push({
                    src: $(this).attr('href'),
                });
            });

            $items.on('click', function (e) {
                e.preventDefault();

                (<any> $).fancybox.open($srcs, {
                    loop: true
                }, $items.index($(this)));
            });
        })
    }

    private static initCookieConsent(): void {
        CookieConsent.run({

            categories: {
                necessary: {
                    enabled: true,
                    readOnly: true
                },
                functional: {
                    enabled: true,
                },
                statistics: {},
                marketing: {}
            },

            language: {
                default: 'pl',
                translations: {
                    pl: {
                        consentModal: {
                            title: 'Na naszej stronie korzystamy z plików cookie',
                            description: 'Aby zapewnić jak najlepsze wrażenia, korzystamy z technologii, takich jak pliki cookie, do przechowywania i/lub uzyskiwania dostępu do informacji o urządzeniu. Zgoda na te technologie pozwoli nam przetwarzać dane, takie jak zachowanie podczas przeglądania lub unikalne identyfikatory na tej stronie. Brak wyrażenia zgody lub wycofanie zgody może niekorzystnie wpłynąć na niektóre cechy i funkcje.',
                            acceptAllBtn: 'Zaakceptuj',
                            acceptNecessaryBtn: 'Odrzuć',
                            showPreferencesBtn: 'Zarządzaj'
                        },
                        preferencesModal: {
                            title: 'Zarządzaj preferencjami cookies',
                            acceptAllBtn: 'Zaakceptuj wszystkie',
                            acceptNecessaryBtn: 'Odrzuć',
                            savePreferencesBtn: 'Zaakceptuj wybrane',
                            closeIconLabel: 'Zamknij',
                            sections: [
                                {
                                    title: 'Zarządzaj zgodą',
                                    description: 'Aby zapewnić jak najlepsze wrażenia, korzystamy z technologii, takich jak pliki cookie, do przechowywania i/lub uzyskiwania dostępu do informacji o urządzeniu. Zgoda na te technologie pozwoli nam przetwarzać dane, takie jak zachowanie podczas przeglądania lub unikalne identyfikatory na tej stronie. Brak wyrażenia zgody lub wycofanie zgody może niekorzystnie wpłynąć na niektóre cechy i funkcje.'
                                },
                                {
                                    title: 'Niezbędne',
                                    description: 'Pliki cookie niezbędne do prawidłowego funkcjonowania witryny.',
                                    linkedCategory: 'necessary'
                                },
                                {
                                    title: 'Funkcjonalne',
                                    description: 'Pliki cookie wymagane do prawidłowego działąnia części elementów na stronie. Nie są wymagane, ale zalecane.',
                                    linkedCategory: 'functional'
                                },
                                {
                                    title: 'Statystyka',
                                    description: 'Pliki cookie wykorzystywane do celów statystycznych.',
                                    linkedCategory: 'statistics'
                                },
                                {
                                    title: 'Marketing',
                                    description: 'Pliki cookie wykorzystywane do celów marketingowych.',
                                    linkedCategory: 'marketing'
                                }
                            ]
                        }
                    }
                }
            }
        });
    }

    private static initMenus(): void {
        var $mainmenu=$('.mainmenu');

        $('.mainmenu__button', $mainmenu).click(function(e) {
            e.preventDefault();

            $mainmenu.toggleClass('mainmenu--opened', !$mainmenu.hasClass('mainmenu--opened'))
            // $('body').toggleClass('body--menuopened', $mainmenu.hasClass('mainmenu--opened'))
        });

        $mainmenu.addClass('mainmenu--inited');
    }

    private static initHtml() {
        this.initMenus();
        this.initCategories();
        // this.initShares();
        this.initSearchBar();
        this.initBigCat();
        this.initProductBoxes();

        this.initGalleries();

        this.initGoTop();

        this.discover();
    }

    private static initRwd() {
        var $header = $('.header');
        $header.addClass('header--noanim');

        $(window).resize(Site.updateFloat);
        $(window).scroll(Site.updateFloat);

        Site.updateFloat();

        $header.removeClass('header--noanim');
    }

    public static evalJs(): void {
        (<any> window)._js = (h: () => void) => {
            h();
        };

        let js = (<any> window)._jslist;

        $.each(js, (k, v) => {
            v();
        });
    }

    public static init() {
        (<any> window).Site = Site;

        SiteProduct.initModule();
        OpenInfo.initModule();
        ObjectFit.initModule();
        Form.init();

        $(document).ready(() => {
            Site.initHtml();
            Site.initRwd();
            SiteProduct.initHtml();
            Site.initCookieConsent();
        });

        $(window).on('load', () => {
            $('body').addClass('body--loaded');

            setTimeout(() => {
                $('body').removeClass('body--loading');
                $('body').trigger('pageloaded');
            }, 1000);
        });
    }
}

Site.init();
